import { render, staticRenderFns } from "./forgot-password-form.vue?vue&type=template&id=d3c46bec&"
import script from "./forgot-password-form.vue?vue&type=script&lang=js&"
export * from "./forgot-password-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports